module.exports = __webpack_public_path__ + "static/media/evacuation-tree.cb9d8ced.svg";